export default __webpack_public_path__ + "0de82a109deeb6297cf6dc59bc618e9b.png";